import { Component, OnInit } from '@angular/core';
import { ClientLimitQuery } from 'src/app/models/limits.model';
import { RpaHttpService } from 'src/app/services/http/rpa-http.service';

@Component({
  selector: 'app-limit-page',
  standalone: false,
  templateUrl: './limit-page.component.html',
  styleUrl: './limit-page.component.scss'
})
export class LimitPageComponent  {

}
